import React from 'react';
import {
    BrowserView,
    MobileView,
    isBrowser,
    isMobile
} from "react-device-detect";
import './index.css'

const LeftTab = (props) => {
    const clickActive = (data) => {
        props.activeClick(data)
    }
    console.log(isMobile, 'isMobile')
    return (
        <div className="col-md-4 col-lg-3 minAccState">

            <div className="leftNavtab heigth100vh">
                {isMobile ?
                    <React.Fragment>
                        <select className="form-control" value={props.activeTab} onChange={(e) => clickActive(e.target.value)}>
                            {props.tabArray.map((curr, index) => {
                                return (

                                    <option key={index} value={curr.name}  > {curr.name}</option>
                                )
                            })}

                        </select>
                    </React.Fragment> :

                    <ul className="leftNavUl" style={{paddingRight: '0px', paddingLeft: '45px'}}>
                        {props.tabArray.map((curr, index) => {
                            return (
                                <li key={index} className={curr.name === props.activeTab ? "activeleftNav" : ""} onClick={() => clickActive(curr.name)}>{curr.name}</li>
                            )
                        })}



                    </ul>}
            </div>
            {props.children}
        </div>
    )
}

export default LeftTab